var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-header",attrs:{"id":"step-header"}},[_c('h3',[_vm._v("Krok "+_vm._s(_vm.step)+"/4")]),(_vm.step !== 2)?_c('h1',[_vm._v(_vm._s(_vm.title)),_c('span',{staticClass:"purple-text"},[_vm._v(".")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }